// removed by extract-text-webpack-plugin
module.exports = {"root":"_2lU1cE6","noResults":"_1TuMw0J"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultHeader/SearchResultHeader.less
 ** module id = 874
 ** module chunks = 0
 **/